import { Environment } from "../../models-v2/Environment";
import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";
import Storage from "../storage/Storage";

const MANAGER_API_URL = process.env.REACT_APP_MANAGER_API;

export class EnvironmentService {
    static async getEnvironments(
        applicationId: string
    ): Promise<Environment[]> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            },
            params: { applicationId }
        };

        const url = MANAGER_API_URL + "/environments";
        const resp = await AxiosService.httpGet(url, config);
        return resp.data;
    }
}
